import api from "./api";
import dayjs from 'dayjs';
import { getCheckoutClientInfo } from "./authService";
import iq_api from "./iqApi";

export const getNameInitials = (name) => {
  if (!name) return '';

  const words = name.trim().split(/\s+/);
  
  if (words.length === 1) {
    return words[0][0].toUpperCase();
  }

  const firstInitial = words[0][0].toUpperCase();
  const lastInitial = words[words.length - 1][0].toUpperCase();

  return firstInitial + lastInitial;
}

export const isValidEmail = (email) => {   
  const validateEmailRegx = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
  if(email.match(validateEmailRegx)){
      return true;     
    }else{
      return false;
    }   
}

export const replaceUnderSquarebySpace = (word) => {
  return word
    ?.replace(/[_\[\]]/g, ' ') // Replace underscores and square brackets with space
    .replace(/\s+/g, ' ')      // Normalize multiple spaces to single space
    .trim()                    // Remove leading/trailing spaces
    .replace(/\b\w/g, char => char.toUpperCase()); // Capitalize first letter of each word
}

// Function to truncate given description upto given length
export const truncateDescription = (description, upToLength) => {
  try {
    let response = [];
    let descriptionLimit = upToLength;
    let isTruncated = description?.length > descriptionLimit;
    let truncatedDescription = isTruncated ? `${description.slice(0, descriptionLimit)} ` : description;
    response['isTruncated'] = isTruncated;
    response['truncated_info'] = truncatedDescription;
    return response;

   } catch (error) {
    console.log(error)
    console.error('Unable to truncate:', error);
    throw error;
   }
};

export const removeMarketAtEnd = (str) => {
  
  const trimmedStr = str.trim();
  
  const marketWord = "market";

  const regex = new RegExp(`${marketWord}$`, 'i');

  // If the string ends with "market", remove it
  if (regex.test(trimmedStr)) {
    return trimmedStr.slice(0, -marketWord.length).trim();
  }

  return trimmedStr;
}

export const formatValueInBillions = (value) => {
  let billionValue = parseFloat(value) / 1000; // Convert from million to billion

  if (billionValue >= 10) {
      return parseFloat(Math.round(billionValue)); // No decimal places
  } else if (billionValue >= 1 && billionValue < 10) {
      return parseFloat(billionValue.toFixed(1)); // 1 decimal place
  } else if (billionValue < 1) {
      return parseFloat(billionValue.toFixed(1)); // 1 decimal place
  }
}

export const smartRevenueDisplay = (amountInMillion) => {
  let amount = parseFloat(amountInMillion); // Amount is in millions
  let suffix = ' Mn'; // Default suffix

  // If the amount is greater than 999 million, convert to billions
  if (amount > 999) {
    amount = amount / 1000; // Convert to billions
    suffix = ' Bn';
  }

  // Handling rounding and decimal places based on the amount
  if (amount >= 10) {
    // Show 1 decimal place for amounts >= 10
    amount = (Math.round(amount * 10) / 10).toFixed(1);
  } else if (amount >= 1) {
    // Show 1 decimal place if the value is less than 10 but more than or equal to 1
    amount = amount.toFixed(1);
  } else if(amount){
    // Keep 1 decimal place for values less than 1
    amount = amount.toFixed(1);
  }
  if(amount){
    return amount + suffix; 
  }else{
    return ''
  }
}

/*
export const formatDateForRecentDevelopments = (dateString) => {
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = months[date.getMonth()];
  const year = String(date.getFullYear()).slice(-2);
  return `${day}-${month}-${year}`;
};
*/

// For browser compatible dates
export const formatDateForRecentDevelopments = (dateString) => {
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  
  // Parse the ISO 8601 date string
  const date = new Date(dateString);

  // Check if the date is valid
  if (isNaN(date.getTime())) {
    return ""; // If invalid date, return empty string
  }

  const day = String(date.getDate()).padStart(2, '0');
  const month = months[date.getMonth()];
  const year = String(date.getFullYear()).slice(-2);

  return `${day}-${month}-${year}`;
};

// For browser compatible dates
export const formatDateForSuperAdmin = (dateString) => {
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  
  // Parse the ISO 8601 date string
  const date = new Date(dateString);

  // Check if the date is valid
  if (isNaN(date.getTime())) {
    return ""; // If invalid date, return empty string
  }

  const day = String(date.getDate()).padStart(2, '0');
  const month = months[date.getMonth()];
  const year = String(date.getFullYear()).slice(-2);

  return `${day}-${month}-${year}`;
};


/*
export const displayFormattedDate = (date_string = "", formatString, show_time_ago = false) => {

  if (date_string.includes('ago')) {
    return date_string;
  }
  
  date_string = date_string.trim();
  date_string = date_string.substring(0, 10); // Nudges somewhere published_date : "2024-10-22 & 2024-10-29". was expected kind of 2024-10-22T00:00:00
  if(!date_string){
    return "";
  }
  
  if(show_time_ago === true){
    return timeAgo(date_string);
  }

  const date = dayjs(date_string); // Parse the ISO date string
  switch (formatString) {
    case 'YYYY-MM-DD':
      return date.format('YYYY-MM-DD');
    case 'DD-MM-YYYY':
      return date.format('DD-MM-YYYY');
    case 'MMM, YYYY':
      return date.format('MMM, YYYY');
    default:
      return date_string; // Return the original string if the format is unknown
  }
};
*/

export const displayFormattedDate = (date_string = "", formatString, show_time_ago = false) => {
  if (!date_string) return ""; // Handle empty values

  if (date_string.includes("ago")) {
    return date_string; // If already in "time ago" format, return as is
  }

  // Adjust regex to match both DD-MM-YYYY and YYYY-MM-DD formats
  const extractedDate = date_string.match(/(\d{2}-\d{2}-\d{4}|\d{4}-\d{2}-\d{2})/)?.[0] || "";

  if (!extractedDate) return date_string; // If no valid date found, return original

  // Safari-compatible date parsing
  const formattedDateStr = extractedDate.replace(/-/g, "/");
  const date = dayjs(new Date(formattedDateStr)); 

  if (!date.isValid()) return extractedDate; // Return original if invalid

  if (show_time_ago) {
    return timeAgo(extractedDate); // Ensure correct format for timeAgo
  }

  switch (formatString) {
    case "YYYY-MM-DD":
      return date.format("YYYY-MM-DD");
    case "DD-MM-YYYY":
      return date.format("DD-MM-YYYY");
    case "DD-MMM-YYYY":
      return date.format("DD-MMM-YYYY");
    case "MMM, YYYY":
      return date.format("MMM, YYYY");
    default:
      return extractedDate; // Return the extracted date if format is unknown
  }
};


export const formatRelevanceScore = (relevance_score) => {
  if(isNaN(relevance_score)){
    return relevance_score;
  }
  return Math.round(relevance_score);
}

export const displayPlusNumberNearedRounding = (number, base = 10) => {
  if (number >= base) {
      const roundedDown = Math.floor(number / base) * base;
      return `${roundedDown}+`;
  }
  return number.toString();
}

export const timeAgo = (inputDate) => {
  if (!inputDate) return "";

  // Convert inputDate to a Safari-compatible format
  const formattedDateStr = inputDate.replace(/-/g, "/"); 
  const date = new Date(formattedDateStr);
  
  if (isNaN(date)) return inputDate; // Return original if invalid

  const now = new Date();
  const diffTime = now - date;

  // Convert to seconds, minutes, hours, and days
  const diffSeconds = Math.floor(diffTime / 1000);
  const diffMinutes = Math.floor(diffSeconds / 60);
  const diffHours = Math.floor(diffMinutes / 60);
  const diffDays = Math.floor(diffHours / 24);

  if (diffDays < 1) return "Today";
  if (diffDays === 1) return "Y'day";
  if (diffDays < 7) return `${diffDays} days ago`;
  if (diffDays < 14) return "1w ago";
  if (diffDays < 21) return "2w ago";
  if (diffDays < 28) return "3w ago";
  if (diffDays <= 30) return "4w ago";

  // Return in "MMM'YY" format if more than or equals to 30 days
  return date.toLocaleDateString("en-US", { month: "short", year: "2-digit" }).replace(" ", "'");
};


export const smartDecimalNumberFormatter = (number) => {

  number = parseFloat(number);

  return Math.abs(number % 1) < 0.01 ? number.toFixed(0) : number.toFixed(2);
}

export const numberWithCommas = (x) => {
  if(x){
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }else{
    return x;
  }  
}

export const ensureProtocol = (url) => {
  if (url && !/^https?:\/\//i.test(url)) {
    return 'https://' + url;
  }
  return url;
}

export const stripUrl = (url) => {
  return url.replace(/^(https?:\/\/)?(www\.)?/, '');
}

/*** Start: Remove Error Screen ***/
export const removeWebpackErrorOverlay = () => {
  const overlayDiv = document.getElementById('webpack-dev-server-client-overlay-div');
  const overlayBackdrop = document.getElementById('webpack-dev-server-client-overlay');
  if (overlayDiv) {
    fadeOut(overlayDiv);
  }
  if (overlayBackdrop) {
    fadeOut(overlayBackdrop);
  }
}
// Helper function to animate fade-out
function fadeOut(element) {
  element.style.transition = "opacity 0.5s ease"; // Adjust time for a slower or faster fade-out
  element.style.opacity = 1;  // Ensure the element is fully visible initially
  setTimeout(() => {
    element.style.opacity = 0;  // Start fade-out
  }, 0);
  setTimeout(() => {
    element.style.display = 'none'; // Remove from the display after fading out
  }, 500); // This should match the duration in the transition (0.5s)
}
/*** End: Remove Error Screen ***/

export const setRecordAsFavourite = async (favObj) => {

  let api_url = "";
  if(favObj.record_type === 'account'){
    api_url = '/bookmarks/add_bookmark_account';
  }else if(favObj.record_type === 'competitor'){
    api_url = '/bookmarks/add_bookmark_competitor';
  }else if(favObj.record_type === 'growth_opportunity'){
    api_url = '/bookmarks/add_bookmark_growth_opportunity';
  }else if(favObj.record_type === 'contact'){
    api_url = '/bookmarks/add_bookmark_contact';
  }
  
  if(api_url){
    try {
      const response = await api.post(api_url, favObj);
      if (response.data.status === 201 || response.data.status === 200) {
        return true;
      }else{
        return false;
      }
    } catch (error) {
      console.error('Failed to Mark Records as Favourite:', error);
      throw error;
    }
  }
}

export const getMyFavouritesByType = async (record_type) => {

  const checkoutClientInfo = getCheckoutClientInfo();

  let favObj = {}
  favObj.type = record_type
  favObj.client_id = checkoutClientInfo?.checkoutClientId || ''

  let api_url = "/bookmarks/get_bookmark_list";

  /*
  if (record_type === 'account' 
    || record_type === 'report'
    || record_type === 'competitor'
    || record_type === 'all'
  ){

  }
  */

  if(api_url){
    try {
      const response = await api.get(api_url, { params: favObj });
      if (response.data.status === 201 || response.data.status === 200) {
        return response?.data?.result?.list || [];
      }else{
        return [];
      }
    } catch (error) {
      console.error('Failed to Fetch Bookmarked Records:', error);
      throw error;
    }
  }
}

export const getUrlDetailsObj = (location, urlParams) => {

  const locationObj = location()
  const urlParamsObj = urlParams()

  const page = locationObj.pathname.split('/')[1];
  // const page_fullPath_params = locationObj.pathname.substring(1).split("/").slice(1);

  const page_params = Object.keys(urlParamsObj).reduce((acc, key) => {
    acc[key] = decodeURIComponent(urlParamsObj[key]);
    return acc;
  }, {});

  const fullPath = locationObj.pathname.substring(1);

  const searchParams = new URLSearchParams(locationObj.search);
  const queryParams = {};
  searchParams.forEach((value, key) => {
    queryParams[key] = value;
  });

  // Combine the page and dynamic params into an object
  const pageParsedData = {
    page,
    page_params,
    query_params: queryParams
  };

  return pageParsedData;
}

export const getUserStatsObject = (type = "", action = "", data = "", page = "", account_id = "") =>{
  let userStat = {
    type: type,
    action: action,
    data: data,
    page: page,
    account_id: account_id,
    // request_page_domain: window.location.hostname,
    // request_page_url: window.location.href
  };
  return userStat;
}

export const getTabType = (activeParentTabKey = "") => {

  var tab_type = "";
  if(activeParentTabKey == 'overview'){
    tab_type = 'Overview'
  }else if(activeParentTabKey == 'business'){
    tab_type = 'Business'
  }else if(activeParentTabKey == 'growth'){
    tab_type = 'Growth Opportunities'
  }else if(activeParentTabKey == 'nudges_and_events'){
    tab_type = 'Nudges & Events'
  }else if(activeParentTabKey == 'questions'){
    tab_type = 'Prompters'
  }else if(activeParentTabKey == 'contacts'){
    tab_type = 'Contacts'
  }else if(activeParentTabKey == 'competitor_insights'){
    tab_type = 'Competitor Insights'
  }else if(activeParentTabKey == 'technology'){
    tab_type = 'Tech Landscape'
  }else if(activeParentTabKey == 'financials'){
    tab_type = 'Financials'
  }else if(activeParentTabKey == 'documents'){
    tab_type = 'Documents'
  }
  return tab_type;
}

export const recordActivity = async (userStat = {}) => {
  try {
    let recordUserStatsUrl = "/user_stats/save_stats";

    if(recordUserStatsUrl){
      try {
        const response = api.post(recordUserStatsUrl, userStat);
        /*
        if (response.status === 201 || response.status === 200) {
          return response?.result?.message || [];
        }else{
          return [];
        }
        */
       return [];
      } catch (error) {
        console.error('Failed to save user stats:', error);
        throw error;
      }
    }
   } catch (error) {
    console.log(error)
    console.error('Unable to add user stats:', error);
    throw error;
   }
}

export const setReviewSectionEntity = async (reviewObj) => {

  let api_url = "/likes/add_like"

  try {
    const response = await api.post(api_url, reviewObj);
    if (response.data.status === 201 || response.data.status === 200) {
      return true;
    }else{
      return false;
    }
  } catch (error) {
    console.error('Failed to Update Review:', error);
    throw error;
  }
  
}

export const setFavouriteSectionEntity = async (reviewObj) => {

  let api_url = "/likes/update_favourite"

  try {
    const response = await api.post(api_url, reviewObj);
    if (response.data.status === 201 || response.data.status === 200) {
      return true;
    }else{
      return false;
    }
  } catch (error) {
    console.error('Failed to Update Review:', error);
    throw error;
  }
  
}


export const fetchReviewSectionEntityList = async (accountName, clientName, section_name = '', entity_code = '') => {

  let api_url = "/likes/get_like_list"

  const reqReviewObj = {
    'account_name': accountName,    
    'client_name': clientName,
    'section': section_name || '',
    'entity_code': entity_code || ''
  }

  try {
    const response = await api.get(api_url, { params: reqReviewObj });
    if (response.data.status === 201 || response.data.status === 200) {
      return response?.data?.result?.list?.likes || [];
    }else{
      return [];
    }
  } catch (error) {
    console.error('Failed to Fetch Review:', error);
    throw error;
  }
  
}

export const getMyLastViewedAccount = async () => {

  let api_url = "/accounts/last_viewed_account";

  if(api_url){
    try {
      const response = await api.get(api_url);
      if (response.data.status === 201 || response.data.status === 200) {
        return response?.data?.result?.list || [];
      }else{
        return [];
      }
    } catch (error) {
      console.error('Failed to Fetch Bookmarked Records:', error);
      throw error;
    }
  }
}

export const getDomainAndClientWiseAccounts = async (search_string, account_industries, isPublic, isPrivate) => {

  let api_url = "/accounts/get_domain_and_client_wise_accounts";

  if(api_url){
    try {
      const response = await api.get(api_url, {params: {
        "search_string": decodeURIComponent(search_string),
        "account_industries": account_industries,
        "isPublic": isPublic, 
        "isPrivate": isPrivate
      }});
      if (response.data.status === 201 || response.data.status === 200) {
        return response?.data?.result?.list || [];
      }else{
        return [];
      }
    } catch (error) {
      console.error('Failed to Fetch getDomainAndClientWiseAccounts Records:', error);
      throw error;
    }
  }
}

export const getApiFieldValue = (action = "") => {
  var param = {field: "", value: ""};
  switch (action) {
    case 'delete':
      param.field = 'is_delete';
      param.value = 1;
      break;
    case 'undo_delete':
      param.field = 'is_delete';
      param.value = 0;
      break;
    case 'status_on':
      param.field = 'status';
      param.value = 1;
      break;
    case 'status_off':
      param.field = 'status';
      param.value = 0;
      break;
    case 'activate':
      param.field = 'is_active';
      param.value = 1;
      break;
    case 'deactivate':
      param.field = 'is_active';
      param.value = 0;
      break;
    case 'is_avail_for_demo_on':
      param.field = 'is_avail_for_demo';
      param.value = 1;
      break;
    case 'is_avail_for_demo_off':
      param.field = 'is_avail_for_demo';
      param.value = 0;
      break;
    case 'verified':
      param.field = 'is_verified';
      param.value = 1;
      break;
    case 'not_verified':
      param.field = 'is_verified';
      param.value = 0;
      break;
    case '':
      param.field = '';
      param.value = '';
      break;
    default:
      param.field = '';
      param.value = '';
      break;
  }
  return param;
}

export const fetchEventsData = async (params) => {
  try {
    const response = await api.post('/events/get_events', params);
    return response;
  } catch (error) {
    console.error('Failed to Fetch fetchEventsData: ', error);
    throw error; 
  }
};


export const fetchCompanyCompareData = async ({
  page_name,
  company1_code,
  company2_code,
  reports_for,
}) => {
  try {
    const response = await api.post("/company_profiles/get_compare_data", {
      page_name,
      company1_code,
      company2_code,
      reports_for,
    });
    return response;
  } catch (error) {
    console.error("Failed to fetchCompanyCompareData: ", error);
    throw error;
  }
};

export const getCompetitors = async (company_name) => {
  try {
    const response = await api.post("/company_profiles/get_competitors", {
      company_name,
    });
    return response;
  } catch (error) {
    console.error("Failed to getCompetitors: ", error);
    throw error;
  }
};

export const getAccountDetails = async (params)=>{
  try {
    const response = await api.get('/accounts/get_accounts', {
      params
    });
    return response;
  
  } catch (error) {
    console.error("Failed to getAccountDetails: ", error);
    throw error;
  }
 
}

export const fetchDynamicTabsData = async (clientName = "", accountName = "") => {
  try {
    const response = await iq_api.post("/chatgpt/get_coustom_tab", {
      client: clientName,
      account: accountName
    });

    return response?.data?.records || [];
  } catch (error) {
    console.error("Failed to dynamic tabs: ", error);
    throw error;
  }
};

export const logCampaignStats = async (statsObj = {}) => {
  try {
    const response = await api.get("/user_stats/track_campaign_logins", { params: statsObj });
    return response?.data || [];
  } catch (error) {
    console.error("Failed to dynamic tabs: ", error);
    throw error;
  }
};